import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import blog1 from "./assets/blog1.jpg";
import blog2 from "./assets/blog2.png";
import blog3 from "./assets/blog3.png";
import blog4 from "./assets/blog4.jpg";
import { FiChevronDown, FiChevronUp, FiClock, FiUser } from "react-icons/fi";

const BlogData = [
    {
        id: 1,
        image: blog1,
        title: "Bir Gol En Fazla Neye Mal Olabilir?",
        content:
            "Andres Escobar, futbolun hem güzelliklerini hem de tehlikelerinin örneklerinden biridir. 13 Mart 1967'de Kolombiya'nın Medellin şehrinde doğan Escobar, genç yaşta futbol tutkusunu ailesinde buldu. Babası, sokaktaki çocuklara futbol eğitimi veren bir organizasyonun kurucusuydu, abisi de profesyonel bir futbolcuydu. Escobar, futbol kariyerine Atletico Nacional'de başladı. Savunmadaki yetenekleriyle dikkat çeken bir futbolcuydu. Futboldaki başarıları, onu ülkesinin milli takımına kadar taşıdı. 1994 Dünya Kupası'nda ülkesini temsil etmek üzere ABD'ye giden Escobar ve Kolombiya takımı büyük umutlarla turnuvaya katıldı. Ancak Amerika karşısında yaşanan talihsiz bir olay, bütün hayatını değiştirecekti. Escobar, Amerikalı oyuncu John Harkes'ın ortasını kesmek isterken kendi kalesine gol attı. Bu gol, Kolombiya'nın 2-1 kaybedip turnuvadan elenmesine yol açtı. Turnuva sonrası Kolombiya'ya dönen Escobar, Medellin'de arkadaşlarıyla gece dışarı çıktı. Gece kulübünden ayrıldıktan sonra otoparkta üç kişiyle tartışmaya başladı. Bu kişilerden biri, uyuşturucu karteline bağlı olduğu iddia edilen Humberto Castro Muñoz'du ve Escobar'ı altı kez vurdu. Ayrıca her kurşun sırasında 'Gol!' diye bağırdığı söylentiler arasında yer almakta. Escobar, hastaneye kaldırıldı ancak kurtarılamadı ve 2 Temmuz 1994 sabahı hayatını kaybetti. Cenazesine 100 binden fazla kişi katıldı ve Medellin'de adına bir heykel dikildi. Andres Escobar'ın ölümü büyük bir şok etkisi yarattı. Ne yazik ki bu olaylardan anlayacağımız üzere, Simon Kuper'in de dediği gibi 'Futbol sadece futbol değildir.'",
        author: "Mehmet Demir",
        readTime: "8 dk",
        category: "Tarih",
        date: "15 Aralık 2024",
    },
    {
        id: 2,
        image: blog2,
        title: "Manchester City",
        content:
            "2022-2023 Premier Lig sezonu başladığında, futbolseverlerin aklında pek çok soru vardı. Pep Guardiola'nın yönettiği Manchester City, yine Premier Lig kupasını kaldırmayı başarabilecek miydi? Yoksa Arsenal, Liverpool ve Manchester United gibi güçlü rakipler bu unvanı City'nin elinden alabilecek miydi? Manchester City, sezona büyük hedeflerle ve dikkat çekici transferlerle başlamıştı. Avrupa'nın en formda golcülerinden biri olan Erling Haaland'ı Borussia Dortmund'dan transfer eden City, aynı takımdan savunma oyuncusu Manuel Akanji'yi de kadrosuna katmıştı. Ancak Pep Guardiola için tek bir santrfor yeterli değildi. Bu nedenle Arjantin'in genç yıldızı Julian Alvarez'i River Plate'den transfer ederek hücum hattını daha da güçlendirdi. Savunma hattında ise altyapıdan Rico Lewis ve Leeds United'dan Kalvin Phillips gibi önemli isimleri takıma dahil ederek yenilenmeye gittiler. Sezonun başında City, yaptığı transferlerin karşılığını hemen aldı ve üst üste galibiyetlerle 10 maç boyunca yenilgi yüzü görmedi. Ancak Premier Lig maçlarının yanı sıra Şampiyonlar Ligi ve FA Cup mücadelesi, yoğun bir fikstür ve sakatlık sorunlarıyla birleşince City için zorlu bir süreç başladı. Tüm bunlara rağmen, City 2022-2023 sezonunda rakipsiz bir görüntü sergiledi. Phil Foden'ın gelişimi, Kevin De Bruyne ve Rodri gibi oyuncuların liderlik vasıfları, takımın performansını zirveye taşıdı. Özellikle, Şampiyonlar Ligi yarı finalinde Real Madrid'e karşı oynadıkları iki maç unutulmazdı. İlk maçta Santiago Bernabéu'da berabere kalan City, rövanşta Etihad Stadı'nda rakibini 4-0 gibi etkileyici bir skorla mağlup etmeyi başardı. Bu başarı, Premier Lig şampiyonluğunu ilan etmeye sadece günler kala elde edildi ve futbol dünyasında büyük bir etki yarattı. Manchester City'nin bu sezonki başarısı, sadece bireysel yıldızların değil, takım olma bilincinin de bir ürünüydü. Pep Guardiola'nın yönetiminde City, tüm zorluklara rağmen hem yerel hem de Avrupa arenasında adını zirveye yazdırmayı başardı.",
        author: "Ahmet Yılmaz",
        readTime: "12 dk",
        category: "Analiz",
        date: "10 Aralık 2024",
    },
    {
        id: 3,
        image: blog3,
        title: "Fenerbahçe'nin Sarı-Lacivert Hikâyesi",
        content:
            "Fenerbahçe Spor Kulübü'nün renkleri, kuruluşundan bugüne dek tarihsel ve kültürel bir arka plana sahiptir. 1907 yılında İstanbul'un Kadıköy semtinde kurulan kulüp, ilk olarak sarı ve beyaz renkleri benimsemiştir. Bu seçim, Fenerbahçe'nin kurucularının çevresindeki doğal güzelliklerden ilham almasının bir sonucuydu. Kadıköy'ün çayırlarında açan papatyalar, sarı ve beyazın seçilmesinde belirleyici oldu. Ancak 1908 yılında, kulübün renklerinde bir değişiklik yapılmasına karar verildi. Dönemin başkanı Nurizade Ziya Bey, takım için daha belirgin ve çarpıcı renkler seçmek istedi. İngiliz bir tüccardan alınan sarı-lacivert çizgili gömlekler, bu dönüşümün başlangıcı oldu. Böylece Fenerbahçe, bugünkü renkleri olan sarı ve laciverte geçti. Sarı ve lacivert renkler, zamanla kulübün kimliğiyle bütünleşti. Sarı, başarıyı ve enerjiyi temsil ederken, lacivert asaletin ve istikrarın simgesi haline geldi. Bu renkler, kulübün kurumsal yapısında ve taraftarların aidiyet duygusunda önemli bir rol oynadı. 1910 yılında Fenerbahçe'nin renkleri, amblemine de yansıdı. Futbolculardan T opuz Hikmet Bey tarafından tasarlanan bu amblem, sarı ve laciverti ön plana çıkarıyordu. Amblemde yer alan meşe dalı, kuvvet ve dayanıklılığı simgelerken, kırmızı zemin Türk bayrağını ve ulusal gururu temsil ediyordu. Böylece sarı-lacivert renkler, Fenerbahçe'nin sembolü haline geldi. Günümüzde Fenerbahçe'nin sarı-lacivert renkleri, kulüp kimliğini oluşturan en önemli unsurlardan biri olarak kabul edilir. Bu renkler, yalnızca saha içindeki başarıları değil, aynı zamanda taraftarlarının kulübe olan bağlılığını ve dayanışmasını temsil eder. Her maçta tribünlerden yükselen sarı-lacivert dalga, bir futbol takımından çok daha fazlasını simgeler; bir kültürü, tarihi ve Fenerbahçe'ye duyulan sonsuz sevgiyi ifade eder.",
        author: "Elif Kaya",
        readTime: "10 dk",
        category: "Tarih",
        date: "5 Aralık 2024",
    },
    {
        id: 4,
        image: blog4,
        title: "Sports Digitale'den Merhaba",
        content:
            "Sports Digitale ailesi olarak sizlere heyecanla duyurmak istediğimiz bir yenilik var: Köşe Yazıları Bölümü! Artık her gün, spor dünyasındaki en güncel gelişmeleri, analizleri, öngörüleri ve daha fazlasını bu yeni bölümde bulabileceksiniz.Sporun her dalından uzman yazarlarımızın kaleminden çıkan yazılarla, sporun nabzını parmaklarınızın ucunda hissedeceksiniz. Bu köşede: Futbol, basketbol, tenis, voleybol ve daha birçok branştan haber ve analizler, Sporcu röportajları ve biyografiler, Turnuva ve müsabaka ön incelemeleri, Sağlık, beslenme ve sporcu psikolojisi gibi konularda bilgilendirici yazılar bulacaksınız. Sporun her anına, her detayına hakim olmak isteyenler için oluşturduğumuz bu bölüm, sporun büyüsünü ve heyecanını her gün size taşıyacak.Günlük köşe yazılarımızla, sporun tadını çıkarmanız ve bilgilenmeniz için buradayız.Siz de bu heyecana ortak olun, her gün Sports Digitale'de buluşalım!",
        author: "Sports Digitale",
        readTime: "5 dk",
        category: "Duyuru",
        date: "1 Aralık 2024",
    },
];

const BlogCard = ({ image, title, content, author, readTime, category, date }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <article className="border-b border-[var(--line)] py-10 first:pt-0">
            <div className="flex flex-col md:flex-row gap-6 md:gap-10">
                <div className="md:w-2/5 shrink-0 overflow-hidden border border-[var(--line)]">
                    <img src={image} alt="" className="w-full h-52 md:h-full object-cover min-h-[200px]" />
                </div>

                <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-[var(--muted)] mb-3">
                        <span className="uppercase tracking-wider text-[var(--accent)]">{category}</span>
                        <span aria-hidden>·</span>
                        <span className="inline-flex items-center gap-1">
                            <FiUser className="w-3.5 h-3.5" />
                            {author}
                        </span>
                        <span aria-hidden>·</span>
                        <span className="inline-flex items-center gap-1">
                            <FiClock className="w-3.5 h-3.5" />
                            {readTime}
                        </span>
                        <span aria-hidden>·</span>
                        <span>{date}</span>
                    </div>

                    <h2 className="font-display text-2xl md:text-3xl text-[var(--ink)] leading-snug">
                        {title}
                    </h2>

                    {!isExpanded && (
                        <p className="mt-3 text-[var(--muted)] leading-relaxed">
                            {content.substring(0, 200)}…
                        </p>
                    )}

                    <button
                        type="button"
                        onClick={() => setIsExpanded(!isExpanded)}
                        className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[var(--accent)] hover:opacity-80 transition-opacity"
                    >
                        {isExpanded ? "Kapat" : "Devamını Oku"}
                        {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                    </button>
                </div>
            </div>

            <AnimatePresence>
                {isExpanded && (
                    <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35 }}
                        className="overflow-hidden"
                    >
                        <p className="mt-6 text-[var(--muted)] leading-relaxed whitespace-pre-line max-w-3xl">
                            {content}
                        </p>
                    </motion.div>
                )}
            </AnimatePresence>
        </article>
    );
};

const Blog = () => {
    return (
        <div className="min-h-screen bg-[var(--bg)]" style={{ paddingTop: 'var(--site-header-h, 3.5rem)' }}>
            <div className="w-11/12 max-w-5xl mx-auto py-16 md:py-20">
                <motion.header
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="mb-12 md:mb-16"
                >
                    <h1 className="font-display text-4xl md:text-6xl text-[var(--ink)]">Blog</h1>
                    <p className="mt-3 text-[var(--muted)] max-w-xl leading-relaxed">
                        Sporun nabzını tutan hikâyeler, analizler ve unutulmaz anlar.
                    </p>
                </motion.header>

                <div>
                    {BlogData.map((blog, index) => (
                        <motion.div
                            key={blog.id}
                            initial={{ opacity: 0, y: 16 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.4, delay: index * 0.05 }}
                        >
                            <BlogCard {...blog} />
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Blog;
